module.exports = __webpack_public_path__ + "static/media/previewlifestyle4-large.66ebdb53.jpg";